import { render, staticRenderFns } from "./StudioOneWidget.vue?vue&type=template&id=41a17c0f&scoped=true"
import script from "./StudioOneWidget.vue?vue&type=script&lang=js"
export * from "./StudioOneWidget.vue?vue&type=script&lang=js"
import style0 from "./StudioOneWidget.vue?vue&type=style&index=0&id=41a17c0f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a17c0f",
  null
  
)

export default component.exports